<template>
    <div>
        <img src="/img/logo_vecindapp.png" alt="" />
    </div>
</template>
<script>
export default {
    data: () => ({
        //
    }),
    computed: {
        //
    },
    methods: {
        //
    },
}
</script>
